import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      camper, // via query
      session, // via query
      camperSession,
      cartProduct,
      locations, // via query
      setCartLocation, // via redux actions
      setCartDays // via redux actions
    } = props

    const { product } = cartProduct || {}

    const handleChangeLocation = e => {
      const locationId = e.target.value
      const location = locations.find(location => location.id === locationId)
      setCartLocation({ camper, session, product, location })

      // reset days to 0 if customer selects no location
      // (they might be intending to remove the product from their cart)
      if (!location) {
        setCartDays({ camper, session, camperSession, days: 0 })
      }
    }

    return (
      <WrappedComponent onChangeLocation={handleChangeLocation} {...props} />
    )
  }
}

export default withEventHandlers
